// The fiat-wallet activity feed unifies the ledger + in-flight recharge,
// withdraw, and rental-payout requests behind one endpoint. There is no
// per-row detail endpoint yet — the drawer renders entirely from the list
// row payload (see useTransactionDrawer). Reintroduce a path constant here
// (e.g. ACTIVITY_DETAIL) the moment the backend ships a unified
// `GET /wallets/fiat/activity/:id`.
export const TRANSACTION_ENDPOINTS = {
  LIST: '/api/wallets/fiat/activity',
  FILTERS: '/api/wallets/fiat/activity/filters',
} as const
